'use client';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';

import { ScShowAllTournamentsCard } from './styled';

export const ShowAllCard = () => {
  const { t } = useTranslation('tournaments');
  return (
    <ScShowAllTournamentsCard>
      <ImageComponent
        alt="tournament"
        className="bg"
        height={206}
        src={'/tournaments/all-tournaments-bg.webp'}
        width={464}
      />
      <ImageComponent
        alt="tournament"
        className="main-img"
        height={236}
        src={'/tournaments/all-tournaments-img.webp'}
        width={320}
      />

      <Button to="/tournaments" wide>
        {t('showAllTournaments')}
      </Button>
    </ScShowAllTournamentsCard>
  );
};
